import { useState } from "react";
import { IDetectedBarcode, Scanner } from "@yudiel/react-qr-scanner";

const WebCamera = ({ onScanFinish }: { onScanFinish: Function }) => {
  const [error, setError] = useState("");

  const isValidQRUrl = (url: string): boolean => {
    const regex =
      /^https?:\/\/\S+\?(?:[^&]*&)*(?:v=[^&]*&?)(?:[^&]*&)*(?:m=[^&]*&?)(?:[^&]*&)*(?:p=[^&]*&?)(?:[^&]*&)*[^&]*$/i;
    return regex.test(url);
  };

  const extractQRParams = (queryPath: string) => {
    const params = new URLSearchParams(queryPath);
    return {
      v: params.get("v") || "",
      m: params.get("m") || "",
      p: params.get("p") || "",
      n: params.get("n") || ""
    };
  };

  const handleScan = (detectedCodes: IDetectedBarcode[]) => {
    console.log("Detected codes:", detectedCodes);
    detectedCodes.forEach((code) => {
      console.log(`Format: ${code.format}, Value: ${code.rawValue}`);
      if (code.format === "qr_code" && isValidQRUrl(code.rawValue)) {
        const urlObj = new URL(code.rawValue);
        const queryPath = urlObj.search;
        const { v, m, p } = extractQRParams(queryPath);
        onScanFinish(v, m, p);
      } else {
        setError("Invalid QR Code");
      }
    });
  };

  return (
    <div className="h-screen">
      {error && <div>{error}</div>}
      <Scanner
        formats={["qr_code"]}
        constraints={{
          facingMode: "environment", // Use rear camera
          aspectRatio: 1,
        }}
        components={{
          finder: false,
        }}
        onScan={handleScan}
        onError={(error: any) => setError(error?.message)}
      />
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-64 h-64 border-2 border-green-500 rounded-lg opacity-75"></div>
      </div>
    </div>
  );
};

export default WebCamera;
